import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Avatar, Box, IconButton, Theme, useMediaQuery } from '@mui/material';
import { usePopover } from '@hooks';
import styles from './styles';
import { AccountPopover } from '../index';

interface TopNavProps {
  onNavOpen: () => void | (() => Promise<void>);
}

/**
 * TopNav Component
 * @param props
 * @param props.onNavOpen
 * @returns {React.Component} Top navigation Component
 */
const TopNav = (props: TopNavProps) => {
  const { onNavOpen } = props;
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
  const accountPopover = usePopover();

  return (
    <AppBar sx={styles.navbar} position='sticky'>
      <Box sx={styles.navLinksContainer}>
        {!lgUp && (
          <IconButton onClick={onNavOpen}>
            <MenuIcon />
          </IconButton>
        )}
      </Box>
      <Box sx={styles.profileDropdownContainer}>
        <Avatar
          onClick={accountPopover.handleOpen}
          ref={accountPopover.anchorRef}
          sx={styles.avatar}
        />
      </Box>
      <AccountPopover
        anchorEl={accountPopover.anchorRef.current}
        open={accountPopover.open}
        onClose={accountPopover.handleClose}
      />
    </AppBar>
  );
};

export default TopNav;
